import * as Blockly from 'blockly/core';

let initialized = false;

function safeUnregister(id: string) {
    const registry = Blockly.ContextMenuRegistry.registry;
    if (registry.getItem(id)) {
        registry.unregister(id);
    }
}

export function initBlockMenu(): void {
    if (initialized) return;
    initialized = true;

    const registry = Blockly.ContextMenuRegistry.registry;

    const idsToRemove = [
        'blockComment',
        'blockCollapseExpand',
        'blockDisable',
        'blockDuplicate',
        'blockDelete',
        'blockInline',
        'duplicateWithNext',
    ];

    for (const id of idsToRemove) {
        safeUnregister(id);
    }

    registry.register({
        id: 'duplicateWithNext',
        displayText: 'ブロックを複製する',
        weight: 1,
        preconditionFn: (scope) => {
            if (!(scope.focusedNode instanceof Blockly.BlockSvg)) return 'hidden';
            const block = scope.focusedNode;
            if (!block.isMovable() || block.isInFlyout) return 'hidden';
            return 'enabled';
        },
        callback: (scope) => {
            if (!(scope.focusedNode instanceof Blockly.BlockSvg)) return;

            const block = scope.focusedNode;
            const ws = block.workspace as Blockly.WorkspaceSvg;
            const root = block.getRootBlock();
            const isRoot = block === root;

            const baseBlock = isRoot ? root : block;
            const baseXy = baseBlock.getRelativeToSurfaceXY();
            const targetX = baseXy.x + 30;
            const targetY = baseXy.y + 30;

            const xml = Blockly.Xml.blockToDom(block, true);
            const dom = xml as Element;
            dom.removeAttribute('id');
            dom.removeAttribute('x');
            dom.removeAttribute('y');
            dom.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            dom.querySelectorAll('[x]').forEach((el) => el.removeAttribute('x'));
            dom.querySelectorAll('[y]').forEach((el) => el.removeAttribute('y'));

            // bumpNeighboursをプロトタイプチェーンで探して一時無効化
            // domToBlock内部およびonInit内の非同期処理でbumpが発動して
            // 元ブロックが動くのを防ぐ
            let proto = Object.getPrototypeOf(block);
            while (proto && !Object.getOwnPropertyDescriptor(proto, 'bumpNeighbours')) {
                proto = Object.getPrototypeOf(proto);
            }
            const origBumpNeighbours = proto?.bumpNeighbours;
            const origScheduleSnapAndBump = proto?.scheduleSnapAndBump;
            if (proto) {
                proto.bumpNeighbours = function () {};
                proto.scheduleSnapAndBump = function () {};
            }

            const newBlock = Blockly.Xml.domToBlock(dom, ws) as Blockly.BlockSvg;
            newBlock.initSvg();
            newBlock.render();

            requestAnimationFrame(() => {
                newBlock.moveTo(new Blockly.utils.Coordinate(targetX, targetY));
                // 非同期で生成される子ブロックもカバーするため2フレーム後に戻す
                requestAnimationFrame(() => {
                    if (proto) {
                        proto.bumpNeighbours = origBumpNeighbours;
                        proto.scheduleSnapAndBump = origScheduleSnapAndBump;
                    }
                });
            });
        },
    });

    registry.register({
        id: 'blockDelete',
        displayText: 'ブロックを削除する',
        weight: 3,
        preconditionFn: (scope) => {
            if (!(scope.focusedNode instanceof Blockly.BlockSvg)) return 'hidden';
            const block = scope.focusedNode;
            if (!block.isDeletable() || block.isInFlyout) return 'hidden';
            return 'enabled';
        },
        callback: (scope) => {
            if (!(scope.focusedNode instanceof Blockly.BlockSvg)) return;
            scope.focusedNode.dispose(true);
        },
    });
}
